import React, { useContext } from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import mobileCredentialApp from "../../../../assets/images/mobileCredential/mobile-credential-app.png";
import visitorInviteApp from "../../../../assets/images/mobileCredential/visitor-invite-app.png";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: mobileCredentialApp,
    label: "Mobile Credential Application",
    description:
      "The app supports all BLE credentials offered by Sicunet, ensuring smooth and secure access for users. Registration is simple and convenient, as users receive an email link directly from the Neptune 2.0 site. By following this link, they can quickly complete the registration process and begin using their BLE credentials without any hassle.",
    imageLeft: true,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "181px",
    sectionHeight: "540px",
  },
  {
    image: visitorInviteApp,
    label: "Visitor Invite through App",
    description:
      "Visitor invitations can be sent easily through the Mobile Credential app. Once the invitation is sent, the visitor will receive an email containing a secure registration link. Using this link, the visitor can register their credential quickly. After completing the registration process, the visitor can access the premises seamlessly using the Mobile Credential app.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "181px",
    sectionHeight: "640px",
    textAlign: "right",
  },
];

export const MobileCredentialContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher
  );
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white w-full">
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
          Mobile Credential & Visitor Access
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[792px]">
          Enable secure BLE-based entry, seamless credential registration, and
          effortless visitor invitations through a unified mobile experience.
        </p>
      </section>

      {/* {isLoggedIn && (
        <div className={`${PAGE_X} max-w-[1440px] mx-auto my-6`}>
          <DownloadSection
            title="Cut Sheet"
            description="Learn about 2.0 Mobile Credential features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="13-5-mhz-mifare-reader"
            showOnlyFirst={true}
          />
        </div>
      )} */}

      <div className="w-full bg-white mt-6">
        {sections.map((section) => (
          <SectionBlock key={section.label} {...section} />
        ))}
      </div>
    </div>
  );
};
